import { router, Stack } from 'expo-router';
import { useEffect } from 'react';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { useAuth } from '@/contexts/authContext';
import { i18n } from '@/utils/i18n';

const PurchaseShow = () => {
  const { state } = useAuth();

  useEffect(() => {
    if (state.authReady && !state.user?.user) {
      if (router.canDismiss()) router.dismissAll();
      router.push('/');
      router.push({
        pathname: '/(app)/login/individual',
        params: {
          buyingShow: 'true'
        }
      });
    }
  }, [state.authReady, state.user?.user]);

  return (
    <PlatformContainer contentCustomClassnames="flex">
      <Stack
        screenOptions={{
          headerShadowVisible: false,
          headerBackVisible: false
        }}>
        <Stack.Screen
          name="index"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={i18n.t('trb_show.purchase')} fontWeight="900" />,
            headerLeft: () => <GoBackButton />
          }}
        />
      </Stack>
    </PlatformContainer>
  );
};

export default PurchaseShow;
